import { render, staticRenderFns } from "./StylingViewModal.vue?vue&type=template&id=052453cd"
import script from "./StylingViewModal.vue?vue&type=script&lang=js"
export * from "./StylingViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports